import {
  SET_UPLOAD_STATUS,
  SET_UPLOAD_STATUS_MESSAGE,
  SET_UPLOAD_SHOW_OFF,
  SET_UPLOAD_FILES,
  OS_FILTER_SHOW_OFF,
  SET_FILES_SENT_STATUS,
  SET_DUPLICATED_ORDERS,
  CLEAR_DUPLICATED_ORDERS,
  SET_UPLOAD_MAINTENANCE_STATUS,
  SET_UPLOAD_MODAL_ERROR,
  SET_UPLOAD_MAINTENANCE_MESSAGE
} from '../types'
import analytics from '@/api/analytics'
import notify from '@/api/notification'
import uploadService from '@/api/uploadXml'
import documentManagement from '@/api/documentManagement'
import router from '../../router'
import { ORDER_STATE_FAIL, ORDER_STATE_PENDING_TRANSMISSION } from '@/enums'
import Moment from 'moment'
import { getCookie } from '@/utils/auth-utils'
import { convertBase64ToFile } from '@/utils/convertBase64ToFile'

const SUCESS_SAVED = 'A ordem de serviço foi atualizada com sucesso.'
const ERROR_SAVED = 'Não foi possível salvar essa operação.'

const state = {
  uploadStatus: 'STATUS_INITIAL',
  uploadStatusMessage: null,
  uploadMaintenanceStatus: 'STATUS_INITIAL',
  uploadMaintenanceMessage: null,
  filesSentStatus: 'STATUS_INITIAL',
  isUploadModalVisible: false,
  isUploadModalErrorVisible: false,
  duplicatedOrders: [],
  files: []
}

const mutations = {
  [SET_UPLOAD_STATUS](state, uploadStatus) {
    state.uploadStatus = uploadStatus
  },
  [SET_UPLOAD_STATUS_MESSAGE](state, uploadStatusMessage) {
    if (uploadStatusMessage === 'UPLOAD_ORDER_STATE_FAILED') {
      state.uploadStatusMessage = 'Falha ao submeter pedido para fila de validação'
    } else {
      state.uploadStatusMessage = uploadStatusMessage
    }

    if (uploadStatusMessage) {
      analytics.pushAnalyticsEvent('error-validation', {
        'msg-error': uploadStatusMessage
      })
    }
  },
  [SET_UPLOAD_SHOW_OFF](state, value) {
    state.isUploadModalVisible = value
  },
  [SET_UPLOAD_MODAL_ERROR](state, value) {
    state.isUploadModalErrorVisible = value
  },
  [SET_DUPLICATED_ORDERS](state, value) {
    state.duplicatedOrders = value
  },
  [CLEAR_DUPLICATED_ORDERS](state) {
    state.duplicatedOrders = []
  },
  [SET_UPLOAD_FILES](state, value) {
    state.files = value
  },
  [SET_FILES_SENT_STATUS](state, value) {
    state.filesSentStatus = value
  },
  [SET_UPLOAD_MAINTENANCE_STATUS](state, value) {
    state.uploadMaintenanceStatus = value
  },
  [SET_UPLOAD_MAINTENANCE_MESSAGE](state, value) {
    state.uploadMaintenanceMessage = value
  }
}

const getters = {
  uploadStatus: state => {
    return state.uploadStatus
  },
  uploadStatusMessage: state => {
    return state.uploadStatusMessage
  },
  isUploadModalVisible: state => {
    return state.isUploadModalVisible
  },
  duplicatedOrdersFromXml: state => {
    return state.duplicatedOrders
  },
  filesUploaded: state => {
    return state.files
  },
  filesSentStatus: state => {
    return state.filesSentStatus
  },
  uploadMaintenanceStatus: state => {
    return state.uploadMaintenanceStatus
  },
  uploadMaintenanceMessage: state => {
    return state.uploadMaintenanceMessage
  },
  isUploadModalErrorVisible: state => {
    return state.isUploadModalErrorVisible
  }
}

const actions = {
  setIsUploadModalError({ commit }, status) {
    commit('SET_UPLOAD_MODAL_ERROR', status)
  },
  setUploadFiles: function ({ commit }, file) {
    commit('SET_UPLOAD_FILES', file)
  },
  uploadFileXml: function ({ commit, dispatch }, file) {
    let analyticsStartTime = Moment(new Date())

    if (file.type !== 'text/xml' && file.type !== 'application/xml') {
      dispatch('setUploadStatusMessage', 'Formato de arquivo inválido.')
      return
    }
    if (file.size === 0) {
      dispatch('setUploadStatusMessage', 'Erro no Upload do Arquivo.')
      return
    }
    commit('SET_UPLOAD_STATUS', 'STATUS_UPLOADING')
    analytics.pushAnalyticsEvent('ga-event', {
      category: 'upload',
      action: 'inicio'
    })
    uploadService
      .sendFile(file)
      .then(response => {
        commit('SET_UPLOAD_STATUS', 'STATUS_SUCCESS')
        analytics.pushAnalyticsEvent('ga-event', {
          category: 'Importação de XML',
          action: 'Sucesso',
          label: file.size
        })
        router.push('/orders?filterBy=' + ORDER_STATE_PENDING_TRANSMISSION + '&filterBy=' + ORDER_STATE_FAIL)
        commit(OS_FILTER_SHOW_OFF, false)
        commit(SET_UPLOAD_SHOW_OFF, false)
        let ignoredOS = parseInt(response.headers['content-ignored-number'])
        let acceptedOS = parseInt(response.headers['content-accepted-number'])
        let fileToRemove = parseInt(response.headers['file-to-remove'])
        let duplicatedOrders = response.data
        if (fileToRemove > 0) {
          uploadService.deleteFile(fileToRemove)
        }
        if (duplicatedOrders.length > 0) {
          commit(SET_DUPLICATED_ORDERS, duplicatedOrders)
          dispatch('setStepperModalVisible', true)
        } else {
          if (ignoredOS > 0) {
            notify({
              title: 'AVISO:',
              message:
                ignoredOS +
                (ignoredOS > 1
                  ? ' Ordens de Serviço duplicadas foram ignoradas.'
                  : ' Ordem de Serviço duplicada foi ignorada.')
            })
          }
        }

        if (acceptedOS > 0) {
          notify({
            title: 'AVISO:',
            message: 'OSˊs importadas estarão disponíveis em instantes.',
            action: {
              title: 'ATUALIZAR',
              handler: reload
            }
          })
        }
        if (acceptedOS > 0) {
          notify({
            title: 'AVISO:',
            message: 'Importação de ' + acceptedOS + ' OS(s) realizada(s) com sucesso.'
          })
        }

        analyticsForUploadTime({
          startTime: analyticsStartTime,
          fileSize: file.size,
          response: 'Sucesso'
        })
      })
      .catch(error => {
        const errorCode = JSON.stringify(error.response.data.code)
        if (errorCode === '"INVALID_COLLECTION_POINT"') {
          commit(SET_UPLOAD_SHOW_OFF, false)
          commit(SET_UPLOAD_MODAL_ERROR, true)
        }
        commit('SET_UPLOAD_STATUS', 'STATUS_FAILED')
        var payload = error.response.data
        commit(SET_UPLOAD_STATUS_MESSAGE, payload.description || payload.message)
        analyticsErrorXSD(payload.description || payload.message)
        analyticsForUploadTime({
          startTime: analyticsStartTime,
          fileSize: file.size,
          response: 'Falha'
        })
      })
  },
  setInitialUploadStatus: function ({ commit }) {
    commit('SET_UPLOAD_STATUS', 'STATUS_INITIAL')
  },
  setInitialMaintenanceStatus: function ({ commit }) {
    commit(SET_UPLOAD_MAINTENANCE_STATUS, 'STATUS_INITIAL')
    commit(SET_UPLOAD_MAINTENANCE_MESSAGE, defaultError)
  },
  setUploadStatusMessage: function ({ commit }, message) {
    commit(SET_UPLOAD_STATUS_MESSAGE, message)
  },
  setUploadModalVisible: function ({ commit }, value) {
    commit(SET_UPLOAD_SHOW_OFF, value)
  },
  updateOsXml: function ({ commit, dispatch }, order) {
    commit(SET_UPLOAD_MAINTENANCE_STATUS, 'STATUS_UPLOADING')
    if (order.state === 'T') {
      let examsIds = filterExamsWithError(order.exams)
      if (examsIds.length > 0) {
        return uploadService
          .deleteOrderDuplicated(order.idOrder, examsIds)
          .then(() => {
            dispatch('updateAfterTransmit', order)
          })
          .catch(error => {
            dispatch('updateAfterTransmit', order)
            analyticsForOrderMaintenance(error.response)
          })
      } else {
        dispatch('updateAfterTransmit', order)
      }
    } else {
      dispatch('updateBeforeTransmit', order)
    }
  },
  updateBeforeTransmit: function ({ commit }, order) {
    return uploadService
      .updateOrderDuplicatedBeforeTransfered(order.idOrder)
      .then(() => {
        commit(SET_UPLOAD_MAINTENANCE_STATUS, 'STATUS_SUCCESS')
        notify({
          title: 'AVISO:',
          message: SUCESS_SAVED
        })
      })
      .catch(() => {
        commit(SET_UPLOAD_MAINTENANCE_STATUS, 'STATUS_FAILED')
        notify({
          title: 'AVISO:',
          message: ERROR_SAVED
        })
      })
  },
  updateAfterTransmit: function ({ commit, rootState }, order) {
    return uploadService
      .updateOrderDuplicatedAfterTransfered(order)
      .then(() => {
        commit(SET_UPLOAD_MAINTENANCE_STATUS, 'STATUS_SUCCESS')
        notify({
          title: 'AVISO:',
          message: SUCESS_SAVED
        })
      })
      .catch(error => {
        var payload = error.response.data
        let errorMsg = ''

        if (error.response.data.code === 'IRREGULAR_LABORATORY' || rootState.authentication.profile.defaulter) {
          errorMsg = 'Identificamos problemas de faturamento que estão restringindo o envio de suas amostras.'
        } else {
          errorMsg = payload.message
        }

        commit(SET_UPLOAD_MAINTENANCE_MESSAGE, errorMsg)
        commit(SET_UPLOAD_MAINTENANCE_STATUS, 'STATUS_FAILED')
        analyticsForOrderMaintenance(errorMsg)
      })
  },
  deleteOsXML: function ({ commit }, order) {
    commit(SET_UPLOAD_MAINTENANCE_STATUS, 'STATUS_UPLOADING')
    let examsIds = filterNewExams(order.exams)
    return uploadService
      .deleteOrderDuplicated(order.idOrder, examsIds)
      .then(() => {
        commit(SET_UPLOAD_MAINTENANCE_STATUS, 'STATUS_SUCCESS')
      })
      .catch(() => {
        commit(SET_UPLOAD_MAINTENANCE_STATUS, 'STATUS_SUCCESS')
      })
  },
  clearDuplicatedOrdersArray: function ({ commit }) {
    commit(CLEAR_DUPLICATED_ORDERS)
  },
  getFilesSent: function ({ commit }, value) {
    commit(SET_FILES_SENT_STATUS, 'STATUS_SUCCESS')
    return uploadService
      .getFilesSent(value.startDate, value.endDate, value.idLaboratory, value.stateList)
      .then(response => {
        commit(SET_UPLOAD_FILES, response.data)
        commit(SET_FILES_SENT_STATUS, 'STATUS_END')
      })
      .catch(error => {
        notify({
          title: 'AVISO:',
          message: 'Houve um erro ao tentar carregar a lista de arquivos XML. Tente Novamente.'
        })
        var payload = error.response.data
        analyticsErrorXSD(payload.description || payload.message)
        commit(SET_FILES_SENT_STATUS, 'STATUS_END')
      })
  },
  uploadDownloadFileUploaded: function ({ commit }, fileId) {
    return documentManagement
      .downloadDocumentUploaded(fileId)
      .then(response => {
        let fileName = response.headers['content-disposition'].split('=')[1]
        let fileExtension = fileName.split('.')[1]
        convertBase64ToFile({
          file: response,
          fileName: fileName,
          fileExtension: fileExtension
        })
        notify({
          title: 'AVISO:',
          message: 'Download realizado com sucesso.'
        })
      })
      .catch(() => {
        notify({
          title: 'AVISO:',
          message: 'Erro ao realizar download. Por favor tente novamente.'
        })
      })
  }
}

let defaultError = 'Não foi possível salvar esta operação.'

let filterExamsWithError = function (exams) {
  return exams.reduce(function (filteredExams, elem) {
    if (elem.added_xml_exam && elem.status === 'E') {
      filteredExams.push(elem.id_exam_order)
    }
    return filteredExams
  }, [])
}

let filterNewExams = function (exams) {
  return exams.reduce(function (filteredExams, elem) {
    if (elem.added_xml_exam) {
      filteredExams.push(elem.id_exam_order)
    }
    return filteredExams
  }, [])
}

let reload = function () {
  window.location.reload()
}

let analyticsErrorXSD = message => {
  analytics.pushAnalyticsEvent('ga-event', {
    category: 'Importação de XML',
    action: message
  })
}

let analyticsForOrderMaintenance = message => {
  analytics.pushAnalyticsEvent('ga-event', {
    category: 'Importação de XML',
    action: 'Manutencao de OS via XML - ' + message
  })
}

let analyticsForUploadTime = ({ startTime, fileSize, response }) => {
  let endTime = Moment(new Date())
  let uploadTime = endTime.diff(startTime, 'seconds')

  let profile = getCookie('profile') || null
  if (profile) {
    analytics.pushAnalyticsEvent('ga-event', {
      category: 'Importação de XML',
      action: 'Tempo de Upload - ' + response,
      label: uploadTime,
      value: uploadTime,
      'id-user': profile.id,
      'id-lab': profile.id_laboratory,
      'name-lab': profile.laboratoryName,
      'file-size': fileSize
    })
  }
}

export default { state, mutations, actions, getters }
export { mutations, actions, getters }
